
<ca-stepper (changeStep)="onChangeStep($event)">
    <ca-step id="step-tipo-vehiculo" label="{{'AUTOS.BUSCADOR_MODELOS.TIPOS_VEHICULO.TITULO' | translate}}">
        <app-tipo-vehiculo (pasoSeleccionado)="irAlPaso(1)"></app-tipo-vehiculo>
    </ca-step>       
    <ca-step [disabled]="idTipoVehiculoSeleccionado===-1" label="{{'AUTOS.BUSCADOR_MODELOS.MARCAS.TITULO' | translate}}">
        <app-marcas (pasoSeleccionado)="irAlPaso(2)"></app-marcas>
    </ca-step>
    <ca-step id="step-modelo" [disabled]="marcaSeleccionada===''" label="{{'AUTOS.BUSCADOR_MODELOS.MODELOS.TITULO' | translate}}">
        <app-modelos></app-modelos>
    </ca-step>
</ca-stepper>
